// action - state management
import * as actionTypes from './actions';

const initialState = {
    currentMenuId: ''
};

// ===========================|| SNACKBAR REDUCER ||=========================== //

const sidebarReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ACTIVE_MENU_ID:
            return {
                ...state,
                currentMenuId: action.menuId
            };

        case actionTypes.CLEAR_MENU_ID:
            return {
                currentMenuId: ''
            };
        default:
            return state;
    }
};

export default sidebarReducer;
